import {Trophy, X, Star, Sparkles, ChevronLeft} from 'lucide-react';
import {theme} from "./RewardSystem";
import {CommonIcon} from "../../../../core/components/icon";
import FileView from "../../../../core/components/file-view";
import RenderIf from "../../../../core/components/render-if";
import {useTakeAward} from "../../api/award";
import handleError from "../../../../core/helper/handelError";

export default function RewardDetailModal({reward, status, onClose, refetchAwards, selectedTeamId}) {
    const {mutate: takeAward, isPending: isPendingTakeAward} = useTakeAward()

    const handleOnClick = () => {
        takeAward({
            awardId: reward?.id,
            teamId: selectedTeamId
        }, {
            onSuccess: () => {
                refetchAwards()
                onClose()
            },
            onError: (error) => {
                handleError(error)
            }
        })
    }
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            style={{background: '#000000aa', backdropFilter: 'blur(8px)'}}
            onClick={onClose}
        >
            <div
                className="relative rounded-3xl p-8 max-w-sm w-full text-center"
                style={{
                    background: `linear-gradient(145deg, ${theme.deep}, ${theme.primary}cc)`,
                    border: `2px solid ${theme.light}44`,
                    boxShadow: `0 0 60px ${theme.accent}33`,
                    animation: 'bounce-in 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 rounded-full p-1.5"
                    style={{background: '#ffffff15'}}
                >
                    <X size={18} color="white"/>
                </button>

                <div
                    className="mx-auto rounded-full overflow-hidden mb-4"
                    style={{
                        width: 100,
                        height: 100,
                        border: `3px solid ${status === 'earned' ? theme.accent : theme.light}`,
                        boxShadow: `0 0 20px ${theme.light}44`,
                    }}
                >
                    <RenderIf cond={!!reward?.fileDetail} falsyElement={
                        <div className="flex full items-center justify-center mt-2">
                            <CommonIcon icon={'award'}/>
                        </div>
                    }>
                        <FileView {...reward?.fileDetail} imageClassName={'object-contain'}/>
                    </RenderIf>
                    {/*<img src={reward.image} alt={reward.title} className="w-full h-full object-cover" />*/}
                </div>
                <h6 className={`text-[#c084fc] text-sm font-bold mb-2`}>{reward?.prefix?.title}</h6>
                <h3 className="text-white text-xl font-bold mb-2">{reward.title}</h3>
                <h4 className={'text-white  mb-2'}>{reward.type === 'user' ? 'فردی' : 'تیمی'}</h4>

                {status === 'earned' && (
                    <div className="flex items-center justify-center gap-2 mb-4">
                        <div className="px-4 py-1.5 rounded-full text-sm font-bold"
                             style={{background: 'linear-gradient(90deg, #22c55e, #16a34a)', color: 'white'}}>
                            دریافت شده
                        </div>
                    </div>
                )}

                {status === 'pending_take' && (
                    <div className="flex items-center justify-center gap-2 mb-4">
                        <div className="px-4 py-1.5 rounded-full text-sm font-bold"
                             style={{background: 'linear-gradient(90deg, #22c55e, #16a34a)', color: 'white'}}>
                            در انتظار تایید مدیر
                        </div>
                    </div>
                )}

                {status === 'available' && (
                    <div className="flex flex-col items-center gap-3">
                        <div className="flex items-center gap-1" style={{color: theme.light}}>
                            <RenderIf cond={reward?.experience}>
                                <Star size={16} fill={theme.accent} stroke={theme.accent}/>
                                <span className="font-bold">{reward.experience} تجربه </span>
                            </RenderIf>
                            <RenderIf cond={reward?.score}>
                                <Star size={16} fill={theme.accent} stroke={theme.accent}/>
                                <span className="font-bold">{reward.score} امتیاز </span>
                            </RenderIf>
                        </div>
                        <RenderIf cond={reward?.messageBeforeTake}>
                            <div className="max-h-[200px] overflow-y-auto text-right whitespace-pre-line" style={{color: theme.light}}>
                                <p>{reward?.messageBeforeTake}</p>
                            </div>
                        </RenderIf>
                        <button
                            className="px-6 py-2.5 rounded-full text-white font-bold text-sm"
                            style={{
                                background: `linear-gradient(90deg, ${theme.accent}, ${theme.primary})`,
                                boxShadow: `0 4px 20px ${theme.accent}44`,
                                transition: 'transform 0.2s, box-shadow 0.2s',
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'scale(1.05)';
                                e.target.style.boxShadow = `0 6px 30px ${theme.accent}66`;
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'scale(1)';
                                e.target.style.boxShadow = `0 4px 20px ${theme.accent}44`;
                            }}
                            onClick={() => handleOnClick()}
                        >
                            دریافت
                        </button>
                    </div>
                )}

                {status === 'locked' && (
                    <>
                        <RenderIf cond={reward?.prerequisites?.length > 0}>
                            <div className="flex gap-2" style={{color: '#888'}}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                     strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                                </svg>
                                <span className={'text-sm flex justify-between'}>
                                پیش‌نیاز:&nbsp;
                            </span>
                            </div>
                            <div className={'flex flex-col'} style={{color: '#888'}}>
                                {reward?.prerequisites?.map((prerequisite, index) => {
                                    return (
                                        <span key={index + '-' + prerequisite?.id + '-' + 'prerequisite'}>
                                            {prerequisite?.title}
                                        </span>
                                    )
                                })}
                            </div>
                        </RenderIf>
                        <RenderIf cond={reward?.experience || reward?.score}>
                            <div className="flex items-center justify-center gap-2" style={{color: '#888'}}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                     strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                                </svg>
                                <RenderIf cond={reward?.experience}>
                                    <span className="text-sm">{reward.experience} تجربه لازم است </span>
                                </RenderIf>
                                <RenderIf cond={reward?.score}>
                                    <span className="text-sm">{reward.score} امتیاز لازم است </span>
                                </RenderIf>
                            </div>
                        </RenderIf>
                    </>
                )}
            </div>
        </div>
    );
}